module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('v-popover', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "offset": "16",
      "options": _vm.options,
      "open": _vm.show,
      "placement": "left"
    }
  }, [_c('button', {
    staticClass: "tooltip-target b3",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "mouseover": function($event) {
        _vm.show = true
      },
      "mouseleave": function($event) {
        _vm.show = false
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-usd-circle fa-fw"
  })]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('div', {
    staticClass: "line good"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Omsætning")]), _vm._v(" "), _c('div', {
    staticClass: "right good"
  }, [_vm._v(_vm._s(_vm._f("realCurrency")(_vm.project.invoices_total ? _vm.project.invoices_total : 0)))])]), _vm._v(" "), _c('div', {
    staticClass: "line bad"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm._f("realNumber")(_vm.project.timelog_hours ? _vm.project.timelog_hours : 0)) + " timer")]), _vm._v(" "), _c('div', {
    staticClass: "right bad"
  }, [_vm._v(_vm._s(_vm._f("realCurrency")(_vm.project.timelog_total ? _vm.project.timelog_total : 0)))])]), _vm._v(" "), _c('div', {
    staticClass: "line bad"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm._f("realNumber")(_vm.project.materials_count ? _vm.project.materials_count : 0)) + " materialer")]), _vm._v(" "), _c('div', {
    staticClass: "right bad"
  }, [_vm._v(_vm._s(_vm._f("realCurrency")(_vm.project.materials_total ? _vm.project.materials_total : 0)))])]), _vm._v(" "), _c('div', {
    staticClass: "divider",
    staticStyle: {
      "margin": "10px 0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "line total"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Dækningsbidrag")]), _vm._v(" "), _c('div', {
    staticClass: "right",
    class: {
      'good': _vm.project.coverage > 0, 'bad': _vm.project.coverage < 0
    }
  }, [_vm._v(_vm._s(_vm._f("realCurrency")(_vm.project.coverage ? _vm.project.coverage : 0)))])])])], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-22a330da", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22a330da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/ProjectTooltip.vue
// module id = 797
// module chunks = 0